import { render, staticRenderFns } from "./PDFPreviewOneKid.vue?vue&type=template&id=7f732b9c&scoped=true"
import script from "./PDFPreviewOneKid.vue?vue&type=script&lang=js"
export * from "./PDFPreviewOneKid.vue?vue&type=script&lang=js"
import style0 from "./PDFPreviewOneKid.vue?vue&type=style&index=0&id=7f732b9c&lang=scss"
import style1 from "./PDFPreviewOneKid.vue?vue&type=style&index=1&id=7f732b9c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f732b9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f732b9c')) {
      api.createRecord('7f732b9c', component.options)
    } else {
      api.reload('7f732b9c', component.options)
    }
    module.hot.accept("./PDFPreviewOneKid.vue?vue&type=template&id=7f732b9c&scoped=true", function () {
      api.rerender('7f732b9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/ByClass/ExcelTableDialog/PDFPreviewOneKid.vue"
export default component.exports